import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody51.css';

import clientimg from '../images/case-study-client51.webp'
import outcome from '../images/outcome51.webp'

import sm1 from '../images/cs51so1.webp'
import sm2 from '../images/cs51so2.webp'
import sm3 from '../images/cs51so3.webp'
import sm4 from '../images/cs51so4.webp'


const Casestudybody51 = () => {

    return (
        <>
        <section className='casestudybody51-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client is a quasi-government real estate developer mandated to deliver large-scale projects and increase home ownership across Saudi Arabia, with a portfolio of 50+ projects across multiple regions</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client required a comprehensive update and actualisation of their business plan, supported by a streamlined process for incorporating financial actuals, automating management reporting and improving performance visibility across business divisions</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody51-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Stakeholder Alignment & Project Mobilisation:</h4>
                          <p>Conducted <span style={{color:"#03A393",fontWeight:700}}> structured workshops to align stakeholders</span> on project objectives, governance structure, project timelines and execution expectations, while ensuring readiness of the required tools and platforms</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Requirements Discovery & Model Diagnostics:</h4>
                          <p>Assessed the <span style={{color:"#03A393",fontWeight:700}}>existing feasibility models</span> and processes to identify key limitations and developed a detailed <span style={{color:"#03A393",fontWeight:700}}>Business Requirements Document</span> covering business model requirements, solution design, tool architecture and testing scenarios</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Project Planning:</h4>
                          <p>Developed a <span style={{color:"#03A393",fontWeight:700}}>comprehensive execution blueprint</span> covering the project plan, resource allocation, technical architecture, risks, dependencies and testing strategies</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Tool Development & Integration:</h4>
                          <p>Developed a <span style={{color:"#03A393",fontWeight:700}}>multi-dimensional feasibility and actualisation tool </span> comprising an Excel-integrated input architecture, Web-based user interface, Python-based model processing engine, FastAPI backend, Cloud SQL database and scenario artefact storage</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>BI Reporting & Performance Visibility:</h4>
                          <p>Designed and implemented <span style={{color:"#03A393",fontWeight:700}}>Power BI dashboards to enable management reporting</span>, KPI tracking and scenario analysis, and <span style={{color:"#03A393",fontWeight:700}}>provide real-time visibility</span> across project- and portfolio-level performance</p>
                        </div>

                        
                      </div>     
                          <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Testing, Deployment & Knowledge Transfer:</h4>
                          <p>Conducted <span style={{color:"#03A393",fontWeight:700}}> quality assurance, user acceptance testing, back-testing and variance analysis</span> against legacy models, followed by training materials, SOPs, user manuals and handover sessions</p>
                        </div>

                        
                      </div>  

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody50-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered a structured, scalable, and business-user friendly feasibility tool that integrated user inputs, backend processing, and BI reporting into a controlled workflow. The solution standardised feasibility assessments, reduced reliance on fragmented legacy models, improved output consistency and enhanced visibility into project- and portfolio-level feasibility outcomes</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody51
